import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GitHubRepoPickerField } from './GitHubRepoPickerField';
import { gitHubRepoPickerValidation } from './validation';

export const GitHubRepoPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GitHubRepoPicker',
    component: GitHubRepoPickerField,
    validation: gitHubRepoPickerValidation,
  }),
);
